import { Icon } from "@mui/material"

export default function ConversationCardPazaramaIcon() {
  return (
    <Icon>
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="15" height="15" rx="2" fill="#0047BA" />
        <text
          x="50%"
          y="50%"
          dominantBaseline="middle"
          textAnchor="middle"
          fill="white"
          fontSize="10"
          fontWeight="bold"
          fontFamily="Arial"
        >
          P
        </text>
      </svg>
    </Icon>
  )
}
